export default __webpack_public_path__ + "static/media/tf.a0a0fd59.svg";